import {AxiosResponse} from 'axios';
import qs from 'qs';

import axios from './index';

type UploadImageSearch = (formData: FormData) => Promise<AxiosResponse<any, any>>;

export const uploadImageSearch: UploadImageSearch = (formData) => {
  const queryString = qs.stringify({
    context: 'search_photo',
    img_type: 'new',
  });

  return axios.post(`/image/upload?${queryString}`, formData, {
    withCredentials: true,
  });
};
